var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pb-0"},[_c('announcement-card',{attrs:{"announcement":_vm.announcement,"switch1Text":"Show on Startup","buttonText":"Got It!"},on:{"button":function($event){return _vm.announcementClick($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }